import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";
export const userDetailsService = async () => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.get(
			`${CONFIG.AUTHURL}/api/v2/student/account`,
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		console.log(error);
	}
};
